import React from 'react';
import { Router, Redirect } from '@reach/router';
import styled from 'styled-components';

import IsAuthenticated from 'components/IsAuthenticated';
import HasRole from 'components/HasRole';
import Navigation from 'components/Navigation';
import NotificationModal from 'components/Modals/NotificationModal';

import Topology from 'pages/Topology';
import Controls from 'pages/Controls';
import Devices from 'pages/Devices';
import UserManagement from 'pages/UserManagement';
import Account from 'pages/Account';
import EditAccount from 'pages/EditAccount';
import Login from 'pages/Login';
import VerifyAccount from 'pages/VerifyAccount';
import ForgotPassword from 'pages/ForgotPassword';
import ResetPassword from 'pages/ResetPassword';
import ActivityLog from 'pages/ActivityLog';
import ChangeLogo from 'pages/ChangeLogo';
import Polling from 'components/Polling';
import MFA from 'pages/MultiFactorAuth';

import { ADMIN_AUTH_ROLES } from 'utils/appConstants';
import Panels from 'components/Panels';
import Configuration from 'pages/Configuration';
import Footer from 'components/Footer';

const productName = window.env.REACT_APP_PRODUCT_NAME;

const enableCustomLogo =
  window.env.REACT_APP_ENABLE_CUSTOM_LOGO_UPLOAD === 'true';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const StyledRouter = styled(Router)`
  flex: 1;
  height: 100%;
  width: 100%;
  display: flex;
  background: #cfd1d3;
  overflow-y: auto;
`;

const UnauthorizedRedirect = ({ props }) => (
  <Redirect from="/" to="/" default noThrow {...props} />
);
const ProtectedUserManagementRoute = HasRole(
  UserManagement,
  ADMIN_AUTH_ROLES,
  UnauthorizedRedirect
);

const ProtectedActivityLogRoute = HasRole(
  ActivityLog,
  ADMIN_AUTH_ROLES,
  UnauthorizedRedirect
);

const ProtectedChangeLogoRoute = HasRole(
  ChangeLogo,
  ADMIN_AUTH_ROLES,
  UnauthorizedRedirect
);

const AuthenticatedRouter = () => {
  return (
    <Panels>
      <StyledRouter primary={false}>
        {/* TODO: add 404 page instead of defaulting to / */}
        <Topology path="/" default />
        <Controls path="/controls" />
        <Devices path="/devices" />
        <Configuration path="/configuration" />
        <ProtectedUserManagementRoute path="/manage-users" />
        <ProtectedActivityLogRoute path="/activity-log" />
        {enableCustomLogo && <ProtectedChangeLogoRoute path="/change-logo" />}
        <Account path="/account" />
        <EditAccount path="/account/edit" />
        <Redirect from="/mfa" to="/" noThrow />
        <Redirect from="/logout" to="/login" noThrow />
      </StyledRouter>
    </Panels>
  );
};

const UnauthenticatedRouter = () => {
  const mfaEnabled = window.env.REACT_APP_MFA_ENABLED === 'true';

  return (
    <>
      <StyledRouter primary={false}>
        <Login path="/login" default />
        {mfaEnabled && <MFA path="/mfa" />}
        <VerifyAccount path="/verify-account" />
        <ForgotPassword path="/forgot-password" />
        <ResetPassword path="/reset-password" />
        <Redirect from="/logout" to="/login" noThrow />
      </StyledRouter>
      <Footer />
    </>
  );
};

const AuthProtectedRouter = IsAuthenticated(
  AuthenticatedRouter,
  UnauthenticatedRouter
);

function App() {
  document.title = 'Kitu ' + productName;
  return (
    <PageContainer>
      <Navigation />
      <NotificationModal />

      <AuthProtectedRouter />
      <Polling />
    </PageContainer>
  );
}

export default App;
